import * as styles from "./OurCentresPage.module.scss";

import React, { useEffect, useState } from "react";

import SEO from "@dogstrust/dt-web-core-lib-front-end/src/components/seo";
import CentreListings from "@dogstrust/dt-web-core-lib-front-end/src/containers/filters/CentreListings/CentreListings";
import IntroOurCentres from "@dogstrust/dt-web-core-lib-front-end/src/containers/introBlocks/IntroOurCentres";
import OurCentresMap from "@dogstrust/dt-web-core-lib-front-end/src/containers/map/OurCentresMap/OurCentresMap";
import {
	useOurCentres,
	usePageManager,
} from "@dogstrust/dt-web-core-lib-front-end/src/context";
import { getSeoProps } from "@dogstrust/dt-web-core-lib-front-end/src/utils/seo";
import { Layout } from "@dogstrust/uk/components/Layout/Layout";

export interface DogIndexPageProps {
	data: Queries.OurCentresPageQuery;
}

import { Head as DefaultHead } from "@dogstrust/dt-web-core-lib-front-end/src/components/Head/Head";

export const Head: React.FC<DogIndexPageProps> = ({
	data: {
		pageData: { title, field_meta_tags, field_hreflang_url },
	},
}) => {
	return (
		<DefaultHead
			pageUrl="/rehoming/our-centres"
			hrefLangUrl={field_hreflang_url}
		>
			<SEO
				{...getSeoProps(field_meta_tags, {
					title: `${title} | Dogs Trust`,
					description:
						"We have dog Rehoming Centres all over the UK. Visit our website to find your nearest Centre and discover how you can help it.",
					canonical_url: `${process.env.GATSBY_DOMAIN_NAME}/rehoming/our-centres`,
					og_type: "article",
					og_url: `${process.env.GATSBY_DOMAIN_NAME}/rehoming/our-centres`,
					og_title: `${title} | Dogs Trust`,
					og_description:
						"We have dog Rehoming Centres all over the UK. Visit our website to find your nearest Centre and discover how you can help it.",
					twitter_cards_type: "summary",
					twitter_cards_description:
						"We have dog Rehoming Centres all over the UK. Visit our website to find your nearest Centre and discover how you can help it.",
					twitter_cards_site: "@DogsTrust",
					twitter_cards_title: `${title} | Dogs Trust`,
					twitter_cards_page_url: `${process.env.GATSBY_DOMAIN_NAME}/rehoming/our-centres`,
				})}
			/>
		</DefaultHead>
	);
};

const OurCentresPage: React.FC<DogIndexPageProps> = ({
	data: {
		allNodeCentre: { nodes: allCentres },
		pageData: { breadcrumbs },
	},
}) => {
	const [shouldInitCentres, setShouldInitCentres] = useState(true);
	const { onLoadOurCentres, resultsCount: totalDogResultsCount } =
		useOurCentres();
	const { usePagination } = usePageManager();

	// biome-ignore lint/correctness/useExhaustiveDependencies: We only want this to run once
	useEffect(() => {
		usePagination(false);
	}, []);

	useEffect(() => {
		if (shouldInitCentres) {
			onLoadOurCentres(allCentres.map((centre) => ({ ...centre })));
			setShouldInitCentres(false);
		}
	}, [allCentres, shouldInitCentres, onLoadOurCentres]);

	return (
		<Layout breadcrumbs={breadcrumbs ? [...breadcrumbs] : []}>
			<div className={styles.ourcentres}>
				<IntroOurCentres
					title={"Our rehoming centres"}
					body={
						totalDogResultsCount > 0
							? `<p>We currently have ${totalDogResultsCount} dogs ready for new homes</p>`
							: "<p>We have hundreds of dogs ready for new homes</p>"
					}
				/>
				<OurCentresMap />
				<CentreListings />
			</div>
		</Layout>
	);
};
export default OurCentresPage;
